import CloseButton from "../../../components/CloseButton/CloseButton"
import FullScreenPage from "../../../components/FullScreenPage/FullScreenPage"
import OfferBox from "../../../components/OfferBox/OfferBox"
import { usePostPurchase } from "../../../context/postPurchaseContext"
import useStrings from "../../../localization/useStrings"
import native from "../../../native/native"
import images from "../../../utils/images"
import styles from "./MonthlyToYearlyPaywall.module.scss"

const MonthlyToYearlyPaywall = () => {
  return (
    <FullScreenPage containerClassName={styles.page}>
      <div className={styles.container}>
        <Content />
        <CTAContainer />
      </div>
    </FullScreenPage>
  )
}

const Content = () => {
  const { state } = usePostPurchase()

  const pricing = state.promoPricing

  const fullPrice = pricing?.yearlyPriceFull.formatted ?? ""
  const discountedPrice = pricing?.yearlyPriceDiscounted.formatted ?? ""
  const monthlyPrice = pricing?.discountedMonthlyPrice.formatted ?? ""

  const discount = pricing?.savingPercent ?? ""
  const globalStrings = useStrings()
  const strings = globalStrings.monthlyToYearly

  return (
    <div className={styles.content_centered_container}>
      <div className={styles.title_container}>
        <label className={styles.title}>
          {strings.titleLine1}
          <br />
          {strings.titleLine2}
        </label>
        <CloseButton
          onClick={() => {
            native.postNativeEvent("close")
          }}
        />
      </div>
      <label className={styles.subtitle}>{strings.subtitleWarning}</label>
      <div className={styles.offer_container}>
        <img className={images.premium.oneTime.lightning.class} />
        <div className={styles.pricing_container}>
          <div className={styles.discount_container}>
            <label className={styles.number}>{discount}</label>
            <div className={styles.percent_container}>
              <label className={styles.percent}>%</label>
              <label className={styles.off}>{globalStrings.off}</label>
            </div>
            <div className={styles.sparkle_container}>
              <img className={images.premium.oneTime.sparkle.class} />
            </div>
          </div>
          <label className={styles.special}>{globalStrings.special}</label>
        </div>
      </div>
      <div className={styles.gradient_discount}>
        <div className={styles.background}></div>
        <label className={`${styles.crossed} ${styles.gradient_text}`}>
          {fullPrice}
        </label>
        <label className={styles.gradient_text}>
          {globalStrings.promo.yearly(discountedPrice)}
        </label>
      </div>
      <OfferBox
        title={strings.offerTitle}
        offerName={strings.offerName}
        bottomRightSubtitle={globalStrings.monthlyPrice(monthlyPrice)}
        subtitleComponent={
          <>
            {strings.yearlySubtitlePrefix} {discountedPrice}
          </>
        }
      />
    </div>
  )
}

const CTAContainer = () => {
  const { actions } = usePostPurchase()
  const strings = useStrings().monthlyToYearly

  return (
    <div className={styles.bottom_container}>
      <div className={styles.bottom_content_container}>
        <button
          className={styles.subscription_button}
          onClick={() => {
            actions.purchasePromo()
          }}
        >
          <label>{strings.subscribeButton}</label>
        </button>
        <label className={styles.cancel_anytime}>{strings.cancelAnytime}</label>
      </div>
    </div>
  )
}

export default MonthlyToYearlyPaywall
